module.exports = __webpack_public_path__ + "img/paper.caab1c0f.png";